module.exports = __webpack_public_path__ + "static/head-38e972396018da105b18c5943dda18b8.svg";